<style lang="less">
    @import "~@/public/less/index.less";
    .zee-search{
        .arco-form-item{
            width: auto; margin-left: 4px; margin-right: 0;
            .arco-form-item-control-wrapper{
                line-height: 100%;
            }
            .select{
                width: 150px;
            }
            :deep(.arco-select-view-single){
                width: 150px !important;
                min-width: 0 !important;
                max-width: 150px !important;
            }
            :deep(.arco-select-view-single .arco-select-view-input){
                min-width: 0;
            }
        }
        .default-item{
            margin: 0;
        }
    }
</style>

<template>
    <div class="zee zee-component zee-search">
        <a-form layout="inline">
            <!--<a-form layout="inline" :autoFormCreate="(form)=>{this.form = form}" v-if="filter">-->
            <template v-for="(column, field) in columns">
                <a-form-item v-if="column.search && column.form==='cascader'">
                    <a-cascader :allow-clear="false"
                                :options="options[field]"
                                :placeholder="column.title"
                                :filterable="true"
                                expand-trigger="hover"
                                :change-on-select="true"
                                v-model="filter[field]"/>
                </a-form-item>
                <a-form-item v-else-if="column.search && (column.form==='select' || column.form==='radio')">
                    <a-select style="width: 150px"
                              class="select"
                              allow-clear
                              :options="options[field]"
                              :placeholder="column.title"
                              v-model="filter[field]" >
                    </a-select>
                </a-form-item>
                <a-form-item v-else-if="column.search && (column.form==='input' || column.form==='textarea')">
                    <a-input :placeholder="column.title" v-model="filter[field]" />
                </a-form-item>
                <!--日期选择-->
                <a-form-item v-else-if="column.form==='datepicker'">
                    <a-date-picker placeholder="选择日期" v-model="filter[field]" format="YYYY-MM-DD" style="width: 200px;" :allow-clear="false" />
                </a-form-item>
                <!--月份选择-->
                <a-form-item v-else-if="column.form==='monthpicker'">
                    <a-date-picker placeholder="选择月份" v-model="filter[field]" format="YYYY-MM" mode="month" style="width: 200px;" :allow-clear="false" />
                </a-form-item>
                <a-form-item v-else-if="column.scopedSlots&&column.scopedSlots.customRender==='apply_states'">
                    <a-select style="width: 150px"
                              class="select"
                              allow-clear
                              :options="[{
                      value: 0,
                      label: '待审'
                    },{
                      value: 1,
                      label: '复审'
                    },{
                      value: 2,
                      label: '通过'
                    },{
                      value: 3,
                      label: '驳回'
                    },]"
                              :placeholder="column.title"
                              v-model="filter[field]" >
                    </a-select>
                </a-form-item>
                <a-form-item v-else>
                    未定义检索类型:{{column.form}}
                </a-form-item>
            </template>
<!--            <a-form-item class="default-item">-->
<!--                <a-input placeholder="名称"-->
<!--                         v-model="filter.name">-->
<!--                    <icon-edit slot="prefix" />-->
<!--                </a-input>-->
<!--            </a-form-item>-->
            <a-form-item class="default-item">
                <a-space>
                    <a-button type="primary" status="normal" @click="bindSubmit"><icon-search />筛选</a-button>
                    <a-button @click="bindCancel">显示全部</a-button>
                </a-space>
            </a-form-item>
        </a-form>
    </div>
</template>

<script>
import moment from 'moment'
import 'moment/locale/zh-cn'
import { IconSearch, IconEdit } from '@arco-design/web-vue/es/icon'

moment.locale('zh-cn')

export default {
    name: 'ZSearch',
    components: {
      IconSearch,
      IconEdit
    },
    props: {
        superColumns: Array,
        superFilter: Object
    },
    data() {
        return {
            filter: {}
        }
    },
    computed: {
        columns() {
            let columns = {}
            for (let k in this.superColumns) {
                if (this.superColumns[k].search) {
                    columns[this.superColumns[k].dataIndex] = this.superColumns[k]
                }
            }
            return columns
        },
        columnsKeyinfo() {
            const data = this.$fan.utils.parse(this.$store.state.page)
            const columns = data.columns || {}
            return columns
        },
        keyinfo() {
            const data = this.$fan.utils.parse(this.$store.state.page)
            const keyinfo = data.keyinfo || {}
            return keyinfo
        },
        options() {
            const data = this.$fan.utils.parse(this.$store.state.page)
            const options = data.options || {}
            return options
        },
    },
    async mounted() {
        // console.log('', this.columns)
        this.filter = await this.recombineDataByUserToForm(this.columnsKeyinfo)
        // console.log(this.filter)
    },
    methods: {
        moment,
        bindSubmit() {
            let filter = this.$fan.utils.parse(this.filter)
            let newFilter = {}
            for(let k in filter) {
                const v = filter[k]
                if (v!=="" && v!==[] && v!=={}) {
                    if (v.constructor === Array) {
                        newFilter[k] = v[v.length-1]
                    } else {
                        if (this.columns[k].form == 'monthpicker') {
                            newFilter[k] = moment(v).format('YYYY-MM')
                        } else {
                            newFilter[k] = v
                        }
                    }
                }
            }
            this.$emit('change', newFilter)
        },
        bindCancel() {
            this.$emit('reloadData')
        },
        // 重组基于用户信息的默认数据
        async recombineDataByUserToForm(columns) {
            const keyinfo = this.$fan.utils.parse(this.keyinfo)
            let filter = {}
            // 修改id_entity
            const userInfo = this.$store.state.user
            if (userInfo.id_auth_role>1 && userInfo.id_entity) {
                let field = false
                if (columns.hasOwnProperty('id_entity')) {
                    field = 'id_entity'
                } else if (columns.hasOwnProperty('id_entity_xiaofang')) {
                    field = 'id_entity_xiaofang'
                } else if (columns.hasOwnProperty('id_base_org')) {
                    field = 'id_base_org'
                }
                if (field) {
                    filter[field] = keyinfo[field][userInfo.id_entity].value
                }
            }
            return filter
        },
        // 级联菜单搜索
        bindSearchCascader(inputValue, path) {
            return (path.some(option => (option.label).toLowerCase().indexOf(inputValue.toLowerCase()) > -1))
        },
    }
}
</script>